import { render, staticRenderFns } from "./SysDict.vue?vue&type=template&id=a81a521e&scoped=true&"
import script from "./SysDict.vue?vue&type=script&lang=js&"
export * from "./SysDict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81a521e",
  null
  
)

export default component.exports